import React from 'react';
import './styles/whatsapp-button.css';
import { useIntl } from "react-intl";

const WhatsAppButton: React.FC = () => {
  const phoneNumber = '+37126462878';
  const phoneNumberV = '+37126460333';
  const intl = useIntl();

  const handleWhatsAppClick = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const normalizedPhoneNumber = phoneNumber.replace('+', '');

    if (isMobile) {
      window.open(`whatsapp://send?phone=${normalizedPhoneNumber}`, '_blank');
    } else {
      window.open(`https://wa.me/${normalizedPhoneNumber}`, '_blank');
    }
  };

  return (
    <div className="whatsapp-button-container">
      <button
        className="whatsapp-button"
        onClick={handleWhatsAppClick}
        title={intl.formatMessage({ id: "whatsapp.chat" })}
        aria-label={intl.formatMessage({ id: "aria.whatsapp" })}
      >
        <img
          src="/images/WhatsApp.svg"
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </button>
    </div>
  );
};

export default WhatsAppButton;
